import PluginDialog from './PluginDialog'

export default PluginDialog